// extracted by mini-css-extract-plugin
export default {"layout":"RootLayout_layout__CsT2C","content":"RootLayout_content__qnRmv"};